import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {
    Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import PageTracker from '../../../common/PageTrackerHelper';
import RVPPrintLavelNewv2 from '../RVPPrintLabelInscanv2/index.vue';
import RVPPrintLabelReviewv2 from '../RVPPrintLabelReviewv2/index.vue';
import RVPPrintLabelRequest from '../RVPPrintLabelRequest/index.vue';
import RVPPrintPendency from '../RVPPrintPendency/index.vue';
import moment from 'moment'
import { onePagerShipmentDetails, updateShipmentStatusForOnePager, getStickerRestrictionFlag, fetchShipmentLabelData, getOnePagerEnabledFlag } from "../../../../services/modules/printlabelservices.js";
import { applySmartInputStyles, clearSmartInputStyles, createClearInputWatcher } from "../../../common/inputStyleHelper";

export default {
    name: 'PrintLabel',
    components: {
        VueElementLoading,
        Treeselect,
        RVPPrintLavelNewv2,
        RVPPrintLabelReviewv2,
        RVPPrintLabelRequest,
        RVPPrintPendency
    },
    mixins: [PageTracker],
    data: function () {
        return {
            shippingID: '',
            username: '',
            hubId: '',
            localuserid: '',
            isLoading: false,
            shipmentDetails: [],
            requestParam: {},
            selected: '',
            shipment: '',
            responseData: '',
            validationerror: '',
            //  centertype:'',
            shipmentData: [],
            prnData: '',
            IsDtoRestrict: false,
            IsRtoRestrict: false,
            userDataKey: '',
            isSelectPrinter: '0',
            isRedirectLoading: false,
            redirectionMsg: 'Redirecting, please wait...',
            isManualEntryRestrict: false,
            ttl: 200,
            keyFiredCount: { 'value': 0 },
            flyerBarcodeList: [],
            /* Fwd Restriction Flag */
            /* TLQC Restriction Flag */
            restrictTLQCModal: false,
            restrictTLQCError: false,
            /* Move Screen Flag */
            screen: '1',

            /* UserRole */
            userrole: "",

            /* GetAPIResponseDetails */
            shipResponseData: "",

            /* Show Request Template */
            showrequest: true,

            /* Reprint Restrict popup */
            isShowReprintPopUp:false,

            /* reprint authorise */
            isShowReprintPopUpReprint: false,

            /* isDtoPaperSheetOnorOFF */
            isDtoPaperSheetOnOrOff:false,

            /* Scanning Input decect */
            lastKeyTime: 0,
            isScannerInput: null,
            threshold: 50, // Fast keystroke threshold
            scanTimeout: null,
            referance :''
        }
    },
    filters: {
        dateFormat: function (date) {
            if (date == null || date == '')
                return '-'
            return moment(date).format('DD-MM-YYYY HH:mm:ss');
        }
    },
    created: function () { },
    watch: {
        shipment: createClearInputWatcher('shipment'),
        shippingID: createClearInputWatcher('shippingID'),
    },  
    async mounted() {
        localStorage.removeItem('printRoute')
        this.userDataKey = window.localStorage.getItem('userUniqueKey');
        var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);

        this.username = userdetail.username;
        this.localuserid = userdetail.userid;
        this.hubId = userdetail.hubdetails[0];
        this.userrole = userdetail.userrole[0].rolename;
        this.isSelectPrinter = window.localStorage.getItem('onepagerprintflag') == 'Old' ? 0 : 1;
        await this.checkStickerRestriction();
        this.checkOnePagerEnabled();
    },
    methods: {
        // Calling Get Shipment Details and Print The Stricker
        submitform() {
            this.referance= this.selected == '0' ? this.$refs.shippingID : this.$refs.shipment;
            this.isLoading = true;
            this.shippingID = (this.selected == 0 && this.shippingID) ? this.shippingID : this.shipment;
            if (this.shippingID == '') {
                this.validationerror = 'Please enter valid AWB/Flyer code';
                this.isLoading = false;
            } else {
                let reqPayload = {
                    "hubId": this.hubId,
                    "userId": this.localuserid,
                    "shippingId": this.shippingID.trim().toUpperCase(),
                    "userRole": this.userrole,
                    "requestedFrom": "Web",
                    "isStickerPrint": (this.selected == '0') ? false : true
                }

                onePagerShipmentDetails(reqPayload, (result) => {
                    try {

                        if (result && result.data && result.data.code == 200) {
                            applySmartInputStyles(this.referance, result.data.lossCategorization,true);
                            this.isLoading = false;
                            this.shipResponseData = result.data.data;
                            this.shippingID = this.shipResponseData.ShippingId;

                            /* Validations */
                            /* Authorised and unAuthorised User validation */
                            /* Pass Param To Anoter Components */
                            this.propsParameter = {
                                shipmentDetails: this.shipResponseData,
                                actionStatus: "",
                                rePrintCount:(this.shipResponseData.dbDetails && this.shipResponseData.dbDetails.printcount > 0) ? this.shipResponseData.dbDetails.printcount : 0
                            }
                            if (this.shipResponseData.dbDetails) {
                                /* Checking Fresh Print Role */
                                this.propsParameter.actionStatus = this.shipResponseData.dbDetails.status;
                                if (!['dto'].includes(this.shipResponseData.shipmentType.toLowerCase()) && this.IsDtoRestrict == false) {
                                    this.reset();
                                    this.$alertify.error("Print can't be taken out as 'Dto Sticker Printing Restriction flag is disabled at this location");
                                } else if ((this.IsDtoRestrict == false) && (this.shipResponseData.currentHubId.toString() == this.hubId.toString()) && (this.shipResponseData.centerType != "PickupFacility")) {
                                    this.reset();
                                    this.$alertify.error("Sticker printing is not possible at this facility due to the absence of a printer");

                                } else if (this.shipResponseData.userPendingShipments  && this.shipResponseData.userPendingShipments.find(obj => obj.shippingid != this.shippingID)) {
                                        this.reset();
                                        this.$alertify.error(this.shipResponseData.userPendingShipments[0].shippingid+" Shipment in " + this.shipResponseData.userPendingShipments[0].status + " state by current user. Can't Scan New Shipment.");
                                    
                                } else if (this.shipResponseData.dbDetails.requestedby != this.localuserid && !['completed','printcancel', 'printreject', 'printfailed', 'reprintcancel'].includes(this.shipResponseData.dbDetails.status)) {
                                    this.reset();
                                    this.$alertify.error("Shipment Already in" + this.shipResponseData.dbDetails.status + " state by another user " + this.shipResponseData.dbDetails.requestedby);
                                
                                } else if (['dto'].includes(this.shipResponseData.shipmentType.toLowerCase()) && this.shipResponseData.dbDetails.printcount == 1 && ['completed'].includes(this.shipResponseData.dbDetails.status) && (this.shipResponseData.currentHubId.toString() == this.hubId.toString()) && (this.shipResponseData.centerType == "PickupFacility")) {
                                    // this.reset();
                                    // this.$alertify.error("Reprint Not Allowed on PickupFacility for DTO Shipment.");
                                    this.checkUserAuthorizedOrNot();
                                } else if (this.shipResponseData.dbDetails.requestedby == this.localuserid && !['completed'].includes(this.shipResponseData.dbDetails.status)) {
                                    if (['printpending'].includes(this.shipResponseData.dbDetails.status)) {
                                        console.log("Print Pending");
                                        this.$alertify.error("shipment status in " + this.shipResponseData.dbDetails.status + " state.");
                                        this.checkUserAuthorizedOrNot();
                                    } else if (['linkingpending'].includes(this.shipResponseData.dbDetails.status)) {
                                        console.log("Linkingpending Pending");
                                        this.$alertify.error("shipment status in " + this.shipResponseData.dbDetails.status + " state.");
                                        this.screen = 2;
                                        this.reset();
                                    } else if (['inscanpending'].includes(this.shipResponseData.dbDetails.status)) {
                                        console.log("Inscanpending Pending");
                                        this.$alertify.error("shipment status in " + this.shipResponseData.dbDetails.status + " state.");
                                        this.screen = 2;
                                        this.reset();
                                    } else if (['printcancel', 'printreject', 'printfailed', 'reprintcancel'].includes(this.shipResponseData.dbDetails.status)) {
                                        console.log("'printcancel','printreject','printfailed','reprintcancel' Pending");
                                        this.$alertify.error("shipment status in " + this.shipResponseData.dbDetails.status + " state.");
                                        if (this.shipResponseData.dbDetails.printcount >= 1) {
                                            this.reprintStricker();
                                        } else {
                                            this.checkUserAuthorizedOrNot();
                                        }
                                    } else if (['tlqcpending'].includes(this.shipResponseData.dbDetails.status)) {
                                        console.log("tlqcpending");
                                        this.$alertify.error("shipment status in " + this.shipResponseData.dbDetails.status + " state.");
                                    } else if (['reviewpending'].includes(this.shipResponseData.dbDetails.status)) {
                                        console.log("Review Pending");
                                        this.$alertify.error("shipment status in " + this.shipResponseData.dbDetails.status + " state.");
                                        this.screen = 3;
                                        this.reset();
                                    }
                                } else if (this.shipResponseData.dbDetails.printcount >= 1) {
                                    this.reprintStricker();
                                } else {
                                    this.isLoading = false;
                                    this.checkUserAuthorizedOrNot();
                                }
                            } else {
                                if (!['dto'].includes(this.shipResponseData.shipmentType.toLowerCase()) && this.IsDtoRestrict == false) {
                                    this.reset();
                                    this.$alertify.error("Print can't be taken out as 'Dto Sticker Printing Restriction flag is disabled at this location");
                                } else if(this.shipResponseData.userPendingShipments && this.shipResponseData.userPendingShipments.find(obj => obj.shippingid != this.shippingID)) {
                                    this.reset();
                                    this.$alertify.error(this.shipResponseData.userPendingShipments[0].shippingid+" Shipment in " + this.shipResponseData.userPendingShipments[0].status + " state by current user. Can't Scan New Shipment.");
                                } else {
                                    this.isLoading = false;
                                    this.checkUserAuthorizedOrNot();
                                }
                               
                            }

                        } else {
                            applySmartInputStyles(this.referance, result.data.lossCategorization, true);
                            this.reset();
                            this.$alertify.error(result.data.message);
                        }
                    } catch (error) {
                        console.log('result-----<<<<-', error);
                        this.reset();
                    }
                })
            }
        },
        closeModelReprint() {
            this.isShowReprintPopUp = false;
        },

        reprintRequest() {
            /* Calling Reprint */
            this.checkUserAuthorizedOrNot();
        },

        /* Printing Done */
        closeModelReturnToPrintPage() {
            this.isShowReprintPopUpReprint = false
        },

        /* Check User Authorised or not Authorised */
        checkUserAuthorizedOrNot() {
            let allowedPrintRole = '';
            if (this.shipResponseData.dbDetails && this.shipResponseData.dbDetails.printcount >= 1) {
                allowedPrintRole = this.shipResponseData.allowedReprintRole.map(item => item.toLowerCase());
            } else {
                allowedPrintRole = this.shipResponseData.allowedPrintRole.map(item => item.toLowerCase());
            }
            /* Checking Fresh Print Role */
            if (allowedPrintRole.includes(this.userrole.toLowerCase())) {

                if (['dto'].includes(this.shipResponseData.shipmentType.toLowerCase()) && this.shipResponseData.dbDetails && ['completed'].includes(this.shipResponseData.dbDetails.status) && (this.shipResponseData.currentHubId.toString() == this.hubId.toString()) && (this.shipResponseData.centerType == "PickupFacility")) {
                    if (this.shipResponseData.paperSheetDetails) {
                        //Showing error
                        this.$alertify.error("The process for this shipment has been already completed. It can't be inscanned again.");
                    }else{
                        /* RTO/DTO/FWD Stricker Printing */
                        if (this.shipResponseData.shipmentType && ['rto', 'dto'].includes(this.shipResponseData.shipmentType.toLowerCase())) {
                            this.rtoDtoStrickerPrint();
                        } else {
                            this.fwdStrickerPrint();
                        }
                    }
                } else if (this.shipResponseData.paperSheetDetails) {
                    /* DTO paper Sheet */
                    let paperSheet_payload = {
                        "hubid": parseInt(this.hubId),
                        "FlyerBarcodeNumber": this.shippingID.trim().toUpperCase(),
                        "IsShippingId": (this.shippingID && this.shippingID.trim().toUpperCase().startsWith('RVP') ? false : true),
                    };

                    this.dtoPaperSheet(paperSheet_payload);

                } else {

                    /* RTO/DTO/FWD Stricker Printing */
                    if (this.shipResponseData.shipmentType && ['rto', 'dto'].includes(this.shipResponseData.shipmentType.toLowerCase())) {
                        this.rtoDtoStrickerPrint();
                    } else {
                        this.fwdStrickerPrint();
                    }
                }
            } else {

                this.isShowReprintPopUpReprint = true;
                this.$alertify.error("You are not authorized to print stickers for this shipment.");
                this.closeModelReprint();
                this.reset();
            }
        },

        /* Generate DTO Paper Sheet */
        dtoPaperSheet(paperSheet_payload) {
            this.isLoading = true;

            fetchShipmentLabelData(paperSheet_payload, (result) => {
                try {
                    /* Update Payload Request */
                    let RequestForNewPrint = {
                        "hubid": this.hubId,
                        "requestedby": this.localuserid,
                        "requestsource": "lm",
                        "shippingid": this.shippingID.trim().toUpperCase(),
                        "shipmenttype": this.shipResponseData.shipmentType,
                        "centertype": this.shipResponseData.centerType,
                        "istlqceligible": this.shipResponseData.isTlqcShipment,
                        "istlqcdone": this.shipResponseData.hasTlqcProcessCompleted,
                        "userrole": this.userrole,
                        "isDtoPaperSheetOnOrOff" : this.isDtoPaperSheetOnOrOff,
                        "flyerbarcode":(this.shipResponseData.Flyerbarcode) ? this.shipResponseData.Flyerbarcode : ""
                    }

                    // if (result.data.type == 'application/pdf') {//result.data.type == 'application/pdf'
                        // const downloadUrl = window.URL.createObjectURL(new Blob([result.data], { type: 'application/pdf' }));

                        // let message = {
                        //     title: '',
                        //     body: `<p>Pdf is generated, Would you like to Download.!</p>`,
                        // };

                        // this.$dialog.alert(message, {
                        //     html: true,
                        //     animation: 'bounce',
                        //     backdropClose: false,
                        //     loader: true,
                        //     loaderMsg: 'Loading PDF, please wait...'
                        // }).then(dialog => {

                        //     // Create a temporary anchor element
                        //     const link = document.createElement('a');

                        //     // Set the download attribute to specify the filename
                        //     link.href = downloadUrl;
                        //     link.download = 'dtopapersheet.pdf';  // You can change 'filename.pdf' to whatever name you want

                        //     // Append the link to the document (it can be any parent element, but we can use document.body)
                        //     document.body.appendChild(link);

                        //     // Trigger a click event on the link to start the download
                        //     link.click();

                        //     // Remove the link after the download has been triggered (cleaning up)
                        //     document.body.removeChild(link);

                        //     // Optionally, revoke the object URL to free up resources
                        //     window.URL.revokeObjectURL(downloadUrl);
                        //     // window.open(downloadUrl);

                        //     dialog.close();
                            
                            if (this.shipResponseData.shipmentType == 'DTO') {
                                if (this.shipResponseData.isTlqcShipment) {
                                    if (this.shipResponseData.hasTlqcProcessCompleted) {
                                        RequestForNewPrint.action = (this.shipResponseData.dbDetails && this.shipResponseData.dbDetails.printcount >=1 ) ? "printdone" : "tlqcdone";
                                        updateShipmentStatusForOnePager(RequestForNewPrint, (result) => {
                                            try {
                                                /* reset All Fields */
                                                this.reset();
                                                this.isLoading = false;
                                                if (result.data.code == 200) {
                                                    this.$alertify.success(result.data.message);
                                                    if(RequestForNewPrint.action == "tlqcdone"){
                                                        this.propsParameter.actionStatus = result.data.status;
                                                        this.propsParameter.rePrintCount = 0;
                                                        this.screen = 2
                                                    }
                                                } else {
                                                    this.$alertify.error(result.data.message);
                                                }
                                            } catch (error) {
                                                console.log('result------', error.message);
                                            }
                                        })

                                    } else {
                                        this.closeModelReprint();
                                        this.restrictTLQCModal = true;
                                        this.restrictTLQCError = 'TL-QC is applicable on this shipment, Please perform TL-QC through mobile app to process the shipment.';

                                        RequestForNewPrint.action ="printdone";
                                        updateShipmentStatusForOnePager(RequestForNewPrint, (result) => {
                                            try {
                                                /* reset All Fields */
                                                this.reset();
                                                this.isLoading = false;
                                                if (result.data.code == 200) {
                                                    this.$alertify.success(result.data.message);
                                                } else {
                                                    this.$alertify.error(result.data.message);
                                                }
                                            } catch (error) {
                                                console.log('result------', error.message);
                                            }
                                        })
                                        /* reset All Fields */
                                        this.reset();
                                    }
                                } else {

                                    RequestForNewPrint.action = "printdone";
                                    updateShipmentStatusForOnePager(RequestForNewPrint, (result) => {
                                        try {
                                            /* reset All Fields */
                                            this.reset();
                                            this.isLoading = false;

                                            if (result.data.code == 200) {
                                                this.$alertify.success(result.data.message);
                                                this.propsParameter.actionStatus = result.data.status;
                                                this.propsParameter.rePrintCount = 0;
                                                this.screen = 2
                                            } else {
                                                this.$alertify.error(result.data.message);
                                            }
                                        } catch (error) {
                                            console.log('result------', error.message);
                                        }
                                    })
                                }

                            } else {
                                RequestForNewPrint.action = "printdone";
                                updateShipmentStatusForOnePager(RequestForNewPrint, (result) => {
                                    try {
                                        /* reset All Fields */
                                        this.reset();
                                        if (result.data.code == 200) {
                                            this.$alertify.success(result.data.message);
                                        } else {
                                            this.$alertify.error(result.data.message);
                                        }
                                    } catch (error) {
                                        console.log('result------', error.message);
                                    }
                                })
                            }

                        // }).catch(() => {
                        //     this.isLoading = false;
                        //     /* reset All Fields */
                        //     // this.reset();
                        // });
                    // } else {
                    //     RequestForNewPrint.action = "printfailed";
                    //     RequestForNewPrint.comment = "Printer Not Connected";
                    //     updateShipmentStatusForOnePager(RequestForNewPrint, (result) => {
                    //         try {
                    //             /* reset All Fields */
                    //             this.reset();

                    //             if (result.code == 200) {
                    //                 this.$alertify.success(result.message);
                    //             } else {
                    //                 this.$alertify.error(result.message);
                    //             }
                    //         } catch (error) {
                    //             console.log('result------', error.message);
                    //         }
                    //     })
                    // }
                } catch (e) {
                    console.log('result------', e.message);
                    /* reset All Fields */
                    this.reset();
                }
            })
        },

        /* Fwd Stricker Printing */
        fwdStrickerPrint() {
            this.prnData = `^XA
                                    ^SZ2^JMA
                                    ^MCY^PMN
                                    ^PW812
                                    ~SD12^MD0^MTD
                                    ~JSN
                                    ~SD25^MD0
                                    ^JZY
                                    ^LH0,0^LRN
                                    ^XZ
                                    ^XA
                                    ^FO3,66
                                    ^GB803,0,3^FS
                                    ^FO2,135
                                    ^GB805,0,3^FS
                                    ^FO3,241
                                    ^GB803,0,3^FS
                                    ^FO3,343
                                    ^GB803,0,3^FS
                                    ^FO3,444
                                    ^GB803,0,3^FS
                                    ^FO3,525
                                    ^GB803,0,3^FS
                                    ^FO400,68
                                    ^GB0,66,3^FS
                                    ^FO180,242
                                    ^GB0,205,3^FS
                                    ^FO135,448
                                    ^GB0,77,3^FS
                                    ^FO393,448
                                    ^GB0,77,3^FS
                                    ^FO504,448
                                    ^GB0,77,3^FS
                                    ^FO215,525
                                    ^GB0,60,3^FS
                                    ^FO361,525
                                    ^GB0,60,3^FS
                                    ^FT20,35
                                    ^CI0
                                    ^A0N,38,30^FDXPRESSBEES^FS
                                    ^FT115,57
                                    ^A0N,17,23^FDDelivering Happiness^FS
                                    ^FT712,54
                                    ^A0N,45,30^FDFWD^FS
                                    ^FT21,118
                                    ^A0N,42,30^FDDelivery Type : ${this.shipResponseData.prnDetails.OrderType}^FS
                                    ^FT450,118
                                    ^A0N,42,30^FD${this.shipResponseData.prnDetails.ProcessCode}^FS
                                    ^FO50,149
                                    ^BY2^BCN,53,N,N^FD>:${this.shipResponseData.prnDetails.ShippingID}^FS
                                    ^FT50,229
                                    ^A0N,25,27^FD${this.shipResponseData.prnDetails.ShippingID}^FS
                                    ^FT20,283
                                    ^A0N,30,20^FDCust Name :-^FS
                                    ^FT20,327
                                    ^A0N,30,20^FDCust Address :-^FS
                                    ^FT190,275
                                    ^A0N,20,25^FD${this.shipResponseData.prnDetails.CustomerName}^FS
                                    ^FT190,310
                                    ^A0N,20,20^FD${this.shipResponseData.prnDetails.CustomerAddress1}^FS
                                    ^FT190,335
                                    ^A0N,20,20^FD${this.shipResponseData.prnDetails.CustomerAddress2}^FS
                                    ^FT20,385
                                    ^A0N,30,20^FDRTO Name :-^FS
                                    ^FT20,430
                                    ^A0N,30,20^FDRTO Address :-^FS
                                    ^FT190,377
                                    ^A0N,20,25^FD${this.shipResponseData.prnDetails.destiRtoHubName}^FS
                                    ^FT190,413
                                    ^A0N,20,20^FD${this.shipResponseData.prnDetails.RTOAddress1}^FS
                                    ^FT190,438
                                    ^A0N,20,20^FD${this.shipResponseData.prnDetails.RTOAddress2}^FS
                                    ^FT20,480
                                    ^A0N,30,20^FDDestination^FS
                                    ^FT20,516
                                    ^A0N,30,20^FDHub :-^FS
                                    ^FT145,510
                                    ^A0N,34,30^FD${this.shipResponseData.prnDetails.destinationhubname}^FS
                                    ^FT410,481
                                    ^A0N,30,20^FDClient^FS
                                    ^FT410,511
                                    ^A0N,30,20^FDName :-^FS
                                    ^FT517,511
                                    ^A0N,34,30^FD${this.shipResponseData.prnDetails.clientName}^FS
                                    ^FT20,565
                                    ^A0N,30,20^FDDelivery Pincode :-^FS
                                    ^FT228,565
                                    ^A0N,28,38^FD${this.shipResponseData.prnDetails.CustomerPinCode}^FS
                                    ^PQ1,0,1,Y
                                    ^XZ`;


            if (this.prnData) {
                this.printstickernew();
            }
        },

        /* RTO/DTO/FWD Stricker Printing */
        rtoDtoStrickerPrint() {

            /* RTO DTO Printing Format */
            if (this.shipResponseData.prnDetails.shipmenttype && this.shipResponseData.prnDetails.shipmenttype.toLowerCase() == 'dto') {
                if (this.isSelectPrinter == '1') {
                    console.log("---DTO New---");


                    this.prnData = `^XA
                        ^SZ2^JMA
                        ^MCY^PMN
                        ^PW812
                        ~JSN
                        ^JZY
                        ^LH0,0^LRN
                        ^XZ
                        ^XA
                        ^FO3,73
                        ^GB803,0,3^FS
                        ^FO3,134
                        ^GB803,0,3^FS
                        ^FO3,240
                        ^GB803,0,3^FS
                        ^FO3,328
                        ^GB803,0,3^FS
                        ^FO3,423
                        ^GB803,0,3^FS
                        ^FO3,516
                        ^GB803,0,3^FS
                        ^FO332,75
                        ^GB0,61,3^FS
                        ^FO482,77
                        ^GB0,250,3^FS
                        ^FO560,77
                        ^GB0,250,3^FS
                        ^FO710,76
                        ^GB0,61,3^FS
                        ^FO149,241
                        ^GB0,350,3^FS
                        ^FO393,425
                        ^GB0,91,3^FS
                        ^FO504,426
                        ^GB0,91,3^FS
                        ^FO301,520
                        ^GB0,65,3^FS
                        ^FT33,43
                        ^CI0`;
                        if(this.shipResponseData.centerType == 'MMFacility' && [true,"true"].includes(this.shipResponseData.IsReverseWeightCaptured)){
                            this.prnData +=`^MMT
                                            ^PW609
                                            ^LL0420
                                            ^LS0
                                            ^FO719,1^GFA,01152,01152,00012,:Z64:eJzt0jFuAjEQBVAbFy59BN8E52Bo1wiJHIOjxFGadHsENkqREksUGGF2Mp6xTYrUqeICPdAw69n5QvzB0XOnBPDNBiA2O4DcDHgqVXGoXcBLqJ0MFrv6Zxv5ezkj1qqltukfQtBPIz1ZUqkjq2XE/jZwe7wDmJl9AFg0PcBME95Nke3zjLPIRN7FbidTmZE7i9y9FsOIcw3Fg3AjLOyNOL7gjGv26Yh2xVlcZl2d5C1K8JZ9v/ru5e7HbmzbnN0K7cnJ7i1Zos37w3rujiqaVh+xqlqdRZ4C91RxNZhu6bqTsAd2RptjoDtv0PoUeC6VhbqwB9yJvAWafa1A+jvbKdj64SlXB+X4vdkdJHvY8nt+w7VMr2RT/PVJu9Af6POF9xXRVw6HokoODe+a914zUHNS3kDNicNSVfNDWUpsszwyVu7WsidLJrklNnpkVdgfGdbQyqlI/J/fzzcXE+tw:7AD7`;
                        }
                        this.prnData +=`^A0N,38,30^FDXPRESSBEES^FS
                        ^FT115,65
                        ^A0N,17,23^FDDelivering Happiness^FS
                        ^FT401,51
                        ^A0N,39,26^FD${this.shipResponseData.prnDetails.dummyRouteCodeData}^FS`;
                        if (this.shipResponseData.centerType == 'MMFacility' && [true, "true"].includes(this.shipResponseData.IsReverseWeightCaptured)) {
                            this.prnData += `^FT690,51`;
                        } else {
                            this.prnData += `^FT730,48`;
                        }
                        this.prnData +=`^A0N,39,26^FD${this.shipResponseData.prnDetails.shipmenttype}^FS
                        ^FT31,114
                        ^A0N,42,30^FDRemarks :-^FS
                        ^FT176,116
                        ^A0N,42,30^FD${this.shipResponseData.prnDetails.remarks}^FS
                        ^FT341,114
                        ^A0N,42,30^FD${this.shipResponseData.prnDetails.rtogcregion + this.shipResponseData.prnDetails.rtogctype}^FS
                        ^FT510,114
                        ^A0N,42,30^FD${this.shipResponseData.prnDetails.destination}^FS
                        ^FT587,114
                        ^A0N,42,30^FD${this.shipResponseData.prnDetails.routenumber}^FS
                        ^FT730,114
                        ^A0N,42,30^FD${this.shipResponseData.prnDetails.routecode}^FS
                        ^FT489,170
                        ^A0N,31,16^FDFlier Code^FS
                        ^FT490,211
                        ^A0N,23,28^FD${this.shipResponseData.prnDetails.truncfliercode}^FS
                        ^FT571,170
                        ^A0N,28,19^FDLast WH Handover Date^FS
                        ^FT570,211
                        ^A0N,23,28^FD${this.shipResponseData.prnDetails.lastwhhandoverdateformated}^FS
                        ^FO18,148
                        ^BY2^BCN,50,N,N^FD>:${this.shipResponseData.prnDetails.shippingid}^FS
                        ^FT140,225
                        ^A0N,25,27^FD${this.shipResponseData.prnDetails.shippingid}^FS
                        ^FT489,295
                        ^A0N,34,18^FDEway Bill^FS
                        ^FT589,296
                        ^A0N,34,28^FD${this.shipResponseData.prnDetails.ewaybill}^FS
                        ^FT22,277
                        ^A0N,34,23^FDVendor^FS
                        ^FT22,311
                        ^A0N,34,23^FDName :-^FS
                        ^FT157,271
                        ^A0N,25,20^FD${this.shipResponseData.prnDetails.vendorname1}^FS
                        ^FT157,297
                        ^A0N,25,20^FD${this.shipResponseData.prnDetails.vendorname2}^FS
                        ^FT157,323
                        ^A0N,25,20^FD${this.shipResponseData.prnDetails.vendorname3}^FS
                        ^FT23,370
                        ^A0N,34,23^FDVendor^FS
                        ^FT23,405
                        ^A0N,34,23^FDAddress :-^FS
                        ^FT158,355
                        ^A0N,17,25^FD${this.shipResponseData.prnDetails.vendoraddress1}^FS
                        ^FT158,375
                        ^A0N,17,25^FD${this.shipResponseData.prnDetails.vendoraddress2}^FS
                        ^FT158,395
                        ^A0N,17,25^FD${this.shipResponseData.prnDetails.vendoraddress3}^FS
                        ^FT158,415
                        ^A0N,17,25^FD${this.shipResponseData.prnDetails.vendoraddress4}^FS
                        ^FT23,465
                        ^A0N,34,23^FDDestination^FS
                        ^FT23,500
                        ^A0N,34,23^FDHub :-^FS
                        ^FT160,455
                        ^A0N,28,25^FD${this.shipResponseData.prnDetails.destinationhub1}^FS
                        ^FT160,480
                        ^A0N,28,25^FD${this.shipResponseData.prnDetails.destinationhub2}^FS
                        ^FT160,505
                        ^A0N,28,25^FD${this.shipResponseData.prnDetails.destinationhub3}^FS
                        ^FT408,465
                        ^A0N,34,22^FDClient^FS
                        ^FT408,498
                        ^A0N,34,22^FDName :-^FS
                        ^FT513,450
                        ^A0N,25,25^FD${this.shipResponseData.prnDetails.clientname1}^FS
                        ^FT513,476
                        ^A0N,25,25^FD${this.shipResponseData.prnDetails.clientname2}^FS
                        ^FT513,500
                        ^A0N,25,25^FD${this.shipResponseData.prnDetails.clientname3}^FS
                        ^FT15,545
                        ^A0N,25,25^FDDelivery^FS
                        ^FT15,570
                        ^A0N,25,25^FDPincode :-^FS
                        ^FT170,554
                        ^A0N,28,38^FD${this.shipResponseData.prnDetails.deliverypincode}^FS
                        ^FT320,548
                        ^A0N,23,16^FDPO ID /^FS
                        ^FT320,570
                        ^A0N,23,16^FDOrderId :-^FS
                        ^FO400,530
                        ^BCN,27,N,N^FD>:${this.shipResponseData.prnDetails.poid}^FS
                        ^FT472,580
                        ^A0N,23,23^FD${this.shipResponseData.prnDetails.poid}^FS
                        ^PQ1,0,1,Y
                        ^XZ`;

                } else {
                    console.log("---DTO Old---");
                    this.prnData = 'n\n' + 'M0751\n' + 'KW0400\n' + 'O0220\n' + 'V0\n' + 'f303\n' + 'D\n' + 'L\n' + 'D11\n' + 'A2\n' + '1X1100002690000L400001\n' + '1921A0602850007XPRESSBEES\n' +
                        '1911A1402740338' + this.shipResponseData.prnDetails.shipmenttype + '\n' +
                        '1X1100002420000L400001\n' +
                        '1911A1202470162' + this.shipResponseData.prnDetails.rtogcregion + '/' + this.shipResponseData.prnDetails.rtogctype + '\n' +
                        '1911A1202470253' + this.shipResponseData.prnDetails.destination + '\n' +
                        '1911A1202470308' + this.shipResponseData.prnDetails.routenumber + '\n' +
                        '1911A1202470347' + this.shipResponseData.prnDetails.routecode + '\n' +
                        '1911A0602740082Delivering Happiness\n' +
                        '1X1100002420144L001027\n' + '1X1100002420244L001027\n' + '1X1100002410289L001028\n' + '1X1100002420344L001027\n' +
                        '1X1100001670000L400001\n' + '1X1100001290000L400001\n' + '1X1100000810000L400001\n' + '1X1100000420000L400001\n' + '1911A0801480007Vendor\n' +
                        '1911A0801360007Name :- \n' + '1911A0801040007Vendor\n' + '1911A0800930007Address :-\n' + '1911A0800590007Destination\n' + '1911A0800470007Hub :-\n' +
                        '1911A0800610197Client\n' + '1911A0800490197Name :-\n' + '1911A0602190298Last WH Handover Date\n' +
                        '1911A1201840303' + this.shipResponseData.prnDetails.lastwhhandoverdateformated + '\n' +
                        '1X1100001670289L001076\n' +
                        '1911A0600660253' + this.shipResponseData.prnDetails.clientname1 + '\n' +
                        '1911A0600570253' + this.shipResponseData.prnDetails.clientname2 + '\n' +
                        '1911A0600480253' + this.shipResponseData.prnDetails.clientname3 + '\n' +
                        '1911A0601140074' + this.shipResponseData.prnDetails.vendoraddress1 + '\n' +
                        '1911A0601050074' + this.shipResponseData.prnDetails.vendoraddress2 + '\n' +
                        '1911A0600960074' + this.shipResponseData.prnDetails.vendoraddress3 + '\n' +
                        '1911A0600870074' + this.shipResponseData.prnDetails.vendoraddress4 + '\n' +
                        '1911A0601530073' + this.shipResponseData.prnDetails.vendorname1 + '\n' +
                        '1911A0601440073' + this.shipResponseData.prnDetails.vendorname2 + '\n' +
                        '1911A0601350073' + this.shipResponseData.prnDetails.vendorname3 + '\n' +
                        '1911A0600660080' + this.shipResponseData.prnDetails.destinationhub1 + '\n' +
                        '1911A0600570080' + this.shipResponseData.prnDetails.destinationhub2 + '\n' +
                        '1911A0600480080' + this.shipResponseData.prnDetails.destinationhub3 + '\n' +
                        '1911A0800180007Delivery Pincode :-\n' + '1X1100000010102L001041\n' +
                        '1911A0802500007Remarks :- ' + this.shipResponseData.prnDetails.remarks + '\n' +
                        '1X1100000430069L001125\n' + '1X1100000430193L001038\n' + '1X1100000420244L001039\n' + '1X1100003000000L400001\n' +
                        '1911A1202740183' + this.shipResponseData.prnDetails.dummyRouteCodeData + '\n' +
                        '1e6205201840010B' + this.shipResponseData.prnDetails.shippingid + '\n' +
                        '1911A0801700066' + this.shipResponseData.prnDetails.shippingid + '\n' +
                        '1X1100001680228L001075\n' + '1911A0602190240Flier Code\n' +
                        '1911A1201840242' + this.shipResponseData.prnDetails.truncfliercode + '\n' +
                        '1a3101800190210' + this.shipResponseData.prnDetails.poid + '\n' +
                        '1911A0600070245' + this.shipResponseData.prnDetails.poid + '\n' +
                        '1911A0600200107' + this.shipResponseData.prnDetails.deliverypincode + '\n' +
                        '1X1100000010137L001042\n' + '1911A0600200145POID/ Order ID\n' +
                        '1911A0801420308' + this.shipResponseData.prnDetails.ewaybill + '\n' +
                        '1X1100001300300L001038\n' + '1911A0801420246E-way Bill\n' + '1X1100001300241L001038\n' +
                        'Q0001\n' +
                        'E\n';
                }
            }
            else if (this.IsRtoRestrict) {
                if (this.isSelectPrinter == '1') {
                    console.log("---RTO New---");
                    this.prnData = `^XA
                    ^SZ2^JMA
                    ^MCY^PMN
                    ^PW812
                    ~JSN
                    ~SD25^MD0
                    ^JZY
                    ^LH0,0^LRN
                    ^XZ
                    ^XA
                    ^FO3,73
                    ^GB803,0,3^FS
                    ^FO2,142
                    ^GB805,0,3^FS
                    ^FO3,248
                    ^GB803,0,3^FS
                    ^FO3,336
                    ^GB803,0,3^FS
                    ^FO8,432
                    ^GB803,0,3^FS
                    ^FO8,524
                    ^GB803,0,3^FS
                    ^FO309,75
                    ^GB0,66,3^FS
                    ^FO466,75
                    ^GB0,66,3^FS
                    ^FO560,75
                    ^GB0,66,3^FS
                    ^FO710,75
                    ^GB0,66,3^FS
                    ^FO560,146
                    ^GB0,101,3^FS
                    ^FO149,249
                    ^GB0,91,3^FS
                    ^FO149,340
                    ^GB0,91,3^FS
                    ^FO148,434
                    ^GB0,91,3^FS
                    ^FO393,435
                    ^GB0,91,3^FS
                    ^FO504,434
                    ^GB0,91,3^FS
                    ^FO215,524
                    ^GB0,60,3^FS
                    ^FO361,524
                    ^GB0,60,3^FS
                    ^FO504,524
                    ^GB0,60,3^FS
                    ^FT33,43
                    ^CI0
                    ^A0N,38,30^FDXPRESSBEES^FS
                    ^FT115,65
                    ^A0N,17,23^FDDelivering Happiness^FS
                    ^FT382,63
                    ^A0N,45,30^FD${this.shipResponseData.prnDetails.dummyRouteCodeData}^FS
                    ^FT712,54
                    ^A0N,45,30^FD${this.shipResponseData.prnDetails.shipmenttype}^FS
                    ^FT21,118
                    ^A0N,42,30^FDDelivery Type : ${this.shipResponseData.prnDetails.deliverytype}^FS
                    ^FT318,118
                    ^A0N,42,30^FD${this.shipResponseData.prnDetails.rtogcregion + this.shipResponseData.prnDetails.rtogctype}^FS
                    ^FT487,118
                    ^A0N,42,30^FD${this.shipResponseData.prnDetails.destination}^FS
                    ^FT592,118
                    ^A0N,42,30^FD${this.shipResponseData.prnDetails.routenumber}^FS
                    ^FT730,118
                    ^A0N,42,30^FD${this.shipResponseData.prnDetails.routecode}^FS
                    ^FO50,149
                    ^BY2^BCN,53,N,N^FD>:${this.shipResponseData.prnDetails.shippingid}^FS
                    ^FT50,229
                    ^A0N,25,27^FD${this.shipResponseData.prnDetails.shippingid}^FS
                    ^FT571,178
                    ^A0N,28,20^FDLast WH Handover Date^FS
                    ^FT571,224
                    ^A0N,30,30^FD${this.shipResponseData.prnDetails.lastwhhandoverdateformated}^FS
                    ^FT20,285
                    ^A0N,34,23^FDVendor^FS
                    ^FT20,320
                    ^A0N,34,23^FDName :-^FS
                    ^FT160,280
                    ^A0N,20,20^FD${this.shipResponseData.prnDetails.vendorname1}^FS
                    ^FT160,317
                    ^A0N,20,20^FD${this.shipResponseData.prnDetails.vendorname2}^FS
                    ^FT20,378
                    ^A0N,34,23^FDVendor^FS
                    ^FT20,413
                    ^A0N,34,23^FDAddress :-^FS
                    ^FT158,356
                    ^A0N,17,25^FD${this.shipResponseData.prnDetails.vendoraddress1}^FS
                    ^FT158,377
                    ^A0N,17,25^FD${this.shipResponseData.prnDetails.vendoraddress2}^FS
                    ^FT158,398
                    ^A0N,17,25^FD${this.shipResponseData.prnDetails.vendoraddress3}^FS
                    ^FT158,419
                    ^A0N,17,25^FD${this.shipResponseData.prnDetails.vendoraddress4}^FS
                    ^FT20,473
                    ^A0N,34,23^FDDestination^FS
                    ^FT20,508
                    ^A0N,34,23^FDHub :-^FS
                    ^FT158,461
                    ^A0N,28,25^FD${this.shipResponseData.prnDetails.destinationhub1}^FS
                    ^FT158,487
                    ^A0N,28,25^FD${this.shipResponseData.prnDetails.destinationhub2}^FS
                    ^FT158,514
                    ^A0N,28,25^FD${this.shipResponseData.prnDetails.destinationhub3}^FS
                    ^FT410,473
                    ^A0N,34,23^FDClient^FS
                    ^FT410,503
                    ^A0N,34,23^FDName :-^FS
                    ^FT517,461
                    ^A0N,25,25^FD${this.shipResponseData.prnDetails.clientname1}^FS
                    ^FT517,491
                    ^A0N,25,25^FD${this.shipResponseData.prnDetails.clientname2}^FS
                    ^FT517,521
                    ^A0N,25,25^FD${this.shipResponseData.prnDetails.clientname3}^FS
                    ^FT20,566
                    ^A0N,34,23^FDDelivery Pincode :-^FS
                    ^FT228,564
                    ^A0N,28,38^FD${this.shipResponseData.prnDetails.deliverypincode}^FS
                    ^FT380,564
                    ^A0N,28,19^FDE-WAY Bill :-^FS
                    ^FT549,562
                    ^A0N,28,38^FD${this.shipResponseData.prnDetails.ewaybill}^FS
                    ^PQ1,0,1,Y
                    ^XZ`;

                } else {
                    console.log("---RTO Old---");
                    this.prnData = 'n\n' + 'M0751\n' + 'KW0400\n' + 'O0220\n' + 'V0\n' + 'f303\n' + 'D\n' + 'L\n' + 'D11\n' + 'A2\n' + '1X1100002690000L400001\n' + '1921A0602850007XPRESSBEES\n' +
                        '1911A1402740337' + this.shipResponseData.prnDetails.shipmenttype + '\n' +
                        '1X1100002420000L400001\n' +
                        '1911A1202470162' + this.shipResponseData.prnDetails.rtogcregion + '/' + this.shipResponseData.prnDetails.rtogctype + '\n' +
                        '1911A1202470253' + this.shipResponseData.prnDetails.destination + '\n' +
                        '1911A1202470308' + this.shipResponseData.prnDetails.routenumber + '\n' +
                        '1911A1202470353' + this.shipResponseData.prnDetails.routecode + '\n' +
                        '1911A0602740082Delivering Happiness\n' +
                        '1X1100002420144L001027\n' + '1X1100002420244L001027\n' + '1X1100002420289L001027\n' + '1X1100002420344L001027\n' + '1X1100001670000L400001\n' + '1X1100001290000L400001\n' +
                        '1X1100000810000L400001\n' + '1X1100000420000L400001\n' +
                        '1e6205201840010B' + this.shipResponseData.prnDetails.shippingid + '\n' +
                        '1911A1001670042' + this.shipResponseData.prnDetails.shippingid + '\n' +
                        '1911A0801480007Vendor\n' + '1911A0801360007Name :- \n' + '1911A0801040007Vendor\n' + '1911A0800930007Address :-\n' + '1911A0800590007Destination\n' +
                        '1911A0800470007Hub :-\n' + '1911A0800610197Client\n' + '1911A0800490197Name :-\n' + '1911A0602190290Last WH Handover Date\n' +
                        '1911A1201840289' + this.shipResponseData.prnDetails.lastwhhandoverdateformated + '\n' +
                        '1X1100001680265L001075\n' +
                        '1911A0600660253' + this.shipResponseData.prnDetails.clientname1 + '\n' +
                        '1911A0600570253' + this.shipResponseData.prnDetails.clientname2 + '\n' +
                        '1911A0600480253' + this.shipResponseData.prnDetails.clientname3 + '\n' +
                        '1911A0601140080' + this.shipResponseData.prnDetails.vendoraddress1 + '\n' +
                        '1911A0601050080' + this.shipResponseData.prnDetails.vendoraddress2 + '\n' +
                        '1911A0600960080' + this.shipResponseData.prnDetails.vendoraddress3 + '\n' +
                        '1911A0600870080' + this.shipResponseData.prnDetails.vendoraddress4 + '\n' +
                        '1911A0601480078' + this.shipResponseData.prnDetails.vendorname1 + '\n' +
                        '1911A0601390078' + this.shipResponseData.prnDetails.vendorname2 + '\n' +
                        '1911A0600660080' + this.shipResponseData.prnDetails.destinationhub1 + '\n' +
                        '1911A0600570080' + this.shipResponseData.prnDetails.destinationhub2 + '\n' +
                        '1911A0600480080' + this.shipResponseData.prnDetails.destinationhub3 + '\n' +
                        '1911A0800170007Delivery Pincode :-\n' + '1X1100000010129L001041\n' +
                        '1911A0800170133' + this.shipResponseData.prnDetails.deliverypincode + '\n' +
                        '1X1100000420194L001039\n' + '1X1100000010194L001042\n' + '1911A0800160197E-way Bill\n' + '1X1100000010274L001042\n' +
                        '1911A0800170285' + this.shipResponseData.prnDetails.ewaybill + '\n' +
                        '1911A0802500007Delivery Type :- ' + this.shipResponseData.prnDetails.deliverytype + '\n' +
                        '1X1100000430069L001125\n' + '1X1100000420244L001039\n' + '1X1100003000000L400001\n' +
                        '1911A1202740183' + this.shipResponseData.prnDetails.dummyRouteCodeData + '\n' + 'Q0001\n' + 'E\n';
                }
            }
            else {
                this.$alertify.error("Shipment not eligible for Printing");
                this.isLoading = false;
            }
            if (this.prnData) {
                this.printstickernew();
            }
            /* RTO DTO Printing Format End */
        },

        /* Stricker Printing RTO/DTO/FWD */
        printstickernew() {
            this.isLoading = true;

            let RequestForNewPrint = {
                "hubid": this.hubId,
                "shippingid": this.shippingID.trim().toUpperCase(),
                "shipmenttype": this.shipResponseData.shipmentType,
                "centertype": this.shipResponseData.centerType,
                "istlqceligible": this.shipResponseData.isTlqcShipment,
                "istlqcdone": this.shipResponseData.hasTlqcProcessCompleted,
                "userrole": this.userrole,
                "action": 'printfailed',
                "isDtoPaperSheetOnOrOff" : this.isDtoPaperSheetOnOrOff,
                "flyerbarcode":(this.shipResponseData.Flyerbarcode) ? this.shipResponseData.Flyerbarcode : ""
            };
            if (this.shipResponseData.dbDetails && this.shipResponseData.dbDetails.printcount > 1) {
                RequestForNewPrint.requestedby = this.shipResponseData.dbDetails.requestedby
                RequestForNewPrint.requestsource = this.shipResponseData.dbDetails.requestsource
            } else {
                RequestForNewPrint.requestedby = this.localuserid;
                RequestForNewPrint.requestsource = 'lm';
            }

            if (['dto'].includes(this.shipResponseData.shipmentType.toLowerCase()) && this.shipResponseData.dbDetails && ['completed'].includes(this.shipResponseData.dbDetails.status) && (this.shipResponseData.currentHubId.toString() == this.hubId.toString()) && (this.shipResponseData.centerType == "PickupFacility")) {
                RequestForNewPrint.pickupreprintflag = true
            }

            /* For Printing Log Request Paylaod */
            let flierRegex = new RegExp("^RVP");
            this.loginput = {
                CurrentHubID: this.hubId,
                PrintedBy: this.username,
                PrintedDate: moment().format('YYYY-MM-DD HH:mm:ss'),
                Status: 'printFailed',
                ShipmentType: this.shipResponseData.shipmentType,
                CreatorsRole: this.userrole
            }
            if (['dto'].includes(this.shipResponseData.shipmentType.toLowerCase())) {
                this.loginput.FlyerCode = flierRegex.test(this.shippingID.trim().toUpperCase()) ? this.shippingID.trim() : this.shipResponseData.Flyerbarcode ? this.shipResponseData.Flyerbarcode : '',
                    this.loginput.FlyerShippingId = this.shipResponseData.prnDetails.shippingid ? this.shipResponseData.prnDetails.shippingid : this.shippingID.trim();
            } else {
                this.loginput.FlyerCode = '';
                this.loginput.FlyerShippingId = this.shipResponseData.prnDetails.ShippingID ? this.shipResponseData.prnDetails.ShippingID : this.shippingID.trim();
            }

            // Delivery
            /* Printing Payload */
            this.input = {
                prnData: this.prnData,
                bagNumber: moment().format('DD-MM-YYYY')
            }

            axios({
                method: "POST",
                url: "http://localhost:4500/printer/printbagsticker",
                data: this.input,
            })
                .then(result => {
                    if (result.data.ResultCode == 100) {
                        this.closeModelReprint();
                        this.loginput.Status = 'printDone';
                        this.addStickerLog(this.loginput);
                        this.$alertify.success(result.data.ReturnMessage);
                        if (this.shipResponseData.shipmentType == 'DTO') {
                            if (this.shipResponseData.isTlqcShipment) {
                                if (this.shipResponseData.hasTlqcProcessCompleted) {
                                    RequestForNewPrint.action = (this.shipResponseData.dbDetails && this.shipResponseData.dbDetails.printcount >=1 ) ? "printdone" : "tlqcdone";
                                    updateShipmentStatusForOnePager(RequestForNewPrint, (result) => {
                                        try {
                                            /* reset All Fields */
                                            this.reset();
                                            this.isLoading = false;
                                            if (result.data.code == 200) {
                                                this.$alertify.success(result.data.message);
                                                if(RequestForNewPrint.action == "tlqcdone"){
                                                    this.propsParameter.actionStatus = result.data.status;
                                                    this.propsParameter.rePrintCount = 1;
                                                    this.screen = 2
                                                }
                                            } else {
                                                this.$alertify.error(result.data.message);
                                            }
                                        } catch (error) {
                                            console.log('result------', error.message);
                                        }
                                    })

                                } else {
                                    this.closeModelReprint();
                                    this.restrictTLQCModal = true;
                                    this.restrictTLQCError = 'TL-QC is applicable on this shipment, Please perform TL-QC through mobile app to process the shipment.';

                                    RequestForNewPrint.action ="printdone";
                                    updateShipmentStatusForOnePager(RequestForNewPrint, (result) => {
                                        try {
                                            /* reset All Fields */
                                            this.reset();
                                            this.isLoading = false;
                                            if (result.data.code == 200) {
                                                this.$alertify.success(result.data.message);
                                            } else {
                                                this.$alertify.error(result.data.message);
                                            }
                                        } catch (error) {
                                            console.log('result------', error.message);
                                        }
                                    })
                                    /* reset All Fields */
                                    this.reset();
                                }
                            } else {

                                RequestForNewPrint.action = "printdone";
                                updateShipmentStatusForOnePager(RequestForNewPrint, (result) => {
                                    try {
                                        /* reset All Fields */
                                        this.reset();
                                        this.isLoading = false;

                                        if (result.data.code == 200) {
                                            this.$alertify.success(result.data.message);
                                            this.propsParameter.actionStatus = result.data.status;
                                            this.propsParameter.rePrintCount = 1;
                                            this.screen = 2
                                        } else {
                                            this.$alertify.error(result.data.message);
                                        }
                                    } catch (error) {
                                        console.log('result------', error.message);
                                    }
                                })
                            }
                        } else {
                            RequestForNewPrint.action = "printdone";
                            updateShipmentStatusForOnePager(RequestForNewPrint, (result) => {
                                try {
                                    /* reset All Fields */
                                    this.reset();
                                    if (result.data.code == 200) {
                                        this.$alertify.success(result.data.message);
                                    } else {
                                        this.$alertify.error(result.data.message);
                                    }
                                } catch (error) {
                                    console.log('result------', error.message);
                                }
                            })
                        }
                        this.closeModelReprint();
                        /* reset All Fields */
                        this.reset();
                    } else {
                        this.addStickerLog(this.loginput);
                        /* Calling Update API Here */
                        RequestForNewPrint.comment = "Printer Not Connected";
                        // updateShipmentStatusForOnePager(RequestForNewPrint, (result) => {
                        //     try {
                        //         /* reset All Fields */
                        //         if (result.data.code == 200) {
                        //             this.$alertify.success(result.data.message);
                        //         } else {
                        //             this.$alertify.error(result.message);
                        //         }
                        //     } catch (error) {
                        //         console.log('result------', error.message);
                        //     }
                        // })
                        this.$alertify.error(result.data.ReturnMessage);
                        this.closeModelReprint();
                        /* reset All Fields */
                        this.reset();
                    }
                }, error => {
                    console.log("Errro block", error);
                    var code = error.response == undefined ? code = 0 : error.response.status;
                    if (code == 500) {
                        this.$alertify.error("Printer API error");
                        RequestForNewPrint.comment = "Printer API error";
                    } else if (error) {
                        this.$alertify.error("Printer not connected")
                        RequestForNewPrint.comment = "Printer Not Connected";
                    }
                    this.addStickerLog(this.loginput);
                    this.closeModelReprint();

                    /* Calling Update API Here */
                    // updateShipmentStatusForOnePager(RequestForNewPrint, (result) => {
                    //     try {
                    //         /* reset All Fields */
                    //         if (result.data.code == 200) {
                    //             this.$alertify.success(result.data.message);
                    //         } else {
                    //             this.$alertify.error(result.message);
                    //         }
                    //     } catch (error) {
                    //         console.log('result------', error.message);
                    //     }
                    // })
                    /* reset All Fields */
                    this.reset();
                })
            this.isLoading = false;
        },



        /* Check Hub Restriction Flag */
        async checkStickerRestriction() {
            this.isLoading = true;
            let payload = {
                "HubId": this.hubId
            }
            await getStickerRestrictionFlag(payload, (result) => {
                try {
                    if (result.data.code == 200) {
                        this.IsDtoRestrict = result.data.data[0].isdtorestrictprinting;
                        this.IsRtoRestrict = result.data.data[0].isrtorestrictprinting;
                        if (!result.data.data[0].flyerBarcodeList) {
                            this.flyerBarcodeList = [];
                        } else {
                            this.flyerBarcodeList = result.data.data[0].flyerBarcodeList
                        }
                        this.flyerBarcodeList.push("2");
                    }
                    else {
                        this.IsDtoRestrict = false;
                        this.IsRtoRestrict = false;
                    }
                    this.ttl = result && result.data && result.data.restrictionRes.ttl ? result.data.restrictionRes.ttl : 200;
                    // this.isManualEntryRestrict = result && result.data && result.data.restrictionRes.isRestriction ? result.data.restrictionRes.isRestriction : false;
                    this.isManualEntryRestrict = true;
                    if (this.IsDtoRestrict == false) {
                        this.selected = '0' // For DTO PaperSheet
                        this.isDtoPaperSheetOnOrOff = true;
                        this.isLoading = false;
                    }
                    else {
                        this.selected = '1' // For RTO/DTO Stricker Printing
                        this.isLoading = false;
                    }
                } catch (e) {
                    console.log('result-----<<<<-', e);
                    this.isLoading = false;
                }
            })
        },

        /* Close TLQC Model */
        closeModelRestrict() {
            this.restrictTLQCModal = false;
            this.restrictTLQCError = '';
        },

        /* Reset All fields */
        reset() {
            this.$validator.reset();
            this.shippingID = '';
            this.isLoading = false;
            this.shipmentDetails = [];
            this.shipment = '';
            this.validationerror = '';
            this.isRedirectLoading = false;
            clearSmartInputStyles(this.referance);
        },

        barcodeevent(event) {
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if (keycode == 13) {
                this.submitform()
            }
        },
        addStickerLog(input) {
            axios({
                method: "POST",
                url: apiUrl.api_url + 'external/RTO/sticker/add/log',
                data: input
            })
                .then(result => {
                    if (result.data.code == 200) {
                        this.$alertify.success('Log Created Successfully');
                        this.reset();
                    } else {
                        this.$alertify.error(result.data.message);
                    }
                }, error => {
                    this.$alertify.error(error.message);
                })
        },
        // Start Disable Manual Entry For Flyer Barcode
        handleDragOver(event) {
            event.preventDefault();
        },
        DelayExecution(f, delay) {
            var timer = null;
            return function () {
                var context = this, args = arguments;
                clearTimeout(timer);
                timer = window.setTimeout(function () {
                    f.apply(context, args);
                },
                    this.ttl || 200);
            };
        },
        KeyHandle() {
            const vm = this;
            vm.keyFiredCount.value = 0;
            if ($("#shippingID").val() != '' && !vm.isKeyUpBound) {
                vm.isKeyUpBound = true;
                $("#shippingID").on("keyup", this.DelayExecution(function (event) {
                    let keycode = (event.keyCode ? event.keyCode : event.which);
                    vm.keyFiredCount.value = vm.keyFiredCount.value + 1;
                    vm.oncallImediate(keycode);
                }));
            }

            if ($("#shipment").val() != '' && !vm.isKeyUpBound) {
                vm.isKeyUpBound = true;
                $("#shipment").on("keyup", this.DelayExecution(function (event) {
                    let keycode = (event.keyCode ? event.keyCode : event.which);
                    vm.keyFiredCount.value = vm.keyFiredCount.value + 1;
                    vm.oncallImediate(keycode);
                }));
            }

        },
        oncallImediate(keycode) {
            let manualEntryDisableCriteria = this.flyerBarcodeList;
            if (this.selected == '0') {
                if ($("#shippingID").val() == '') {
                    this.keyFiredCount.value = 0;
                    return false;
                }
                else if (($("#shippingID").val() != '') && this.keyFiredCount.value <= 1 && keycode == 13) {
                    if ($("#shippingID").val().trim().toUpperCase().startsWith('2')) {
                        this.$alertify.error('Please Scan Flyerbarcode for DTO Shipment.');
                        if (this.shippingID) {
                            this.shippingID = '';
                        }
                    } else {
                        console.log('Input given from scanner.!');
                        this.submitform()
                    }
                }
                else {
                    if (manualEntryDisableCriteria.some(prefix => $("#shippingID").val().trim().toUpperCase().startsWith(prefix)) && this.keyFiredCount.value <= 1 && keycode != 13) {
                        this.$alertify.error('Please Enter/Scan AWB for RTO or Scan Flyer Barcode for DTO');
                        if (this.shippingID) {
                            this.shippingID = "";
                        }
                        return false;
                    } else {
                        console.log('User Input detection.!');
                        this.$alertify.error('Please Scan Flyer Barcode for DTO');
                        if (this.shippingID) {
                            this.shippingID = "";
                        }
                        return false;
                    }
                }
            }
            if (this.selected == '1') {

                if ($("#shipment").val() == '') {
                    this.keyFiredCount.value = 0;
                    return false;
                }
                else if ($("#shipment").val() != '' && this.keyFiredCount.value <= 1 && keycode == 13) {
                    if ($("#shipment").val().trim().toUpperCase().startsWith('2')) {
                        this.$alertify.error('Please Scan Flyerbarcode for DTO Shipment.');
                        if (this.shipment) {
                            this.shipment = '';
                        }
                    } else {
                        console.log('Input given from scanner.!');
                        this.submitform()
                    }
                }
                else {
                    if (manualEntryDisableCriteria.some(prefix => $("#shipment").val().trim().toUpperCase().startsWith(prefix)) && this.keyFiredCount.value <= 1 && keycode != 13) {
                        this.$alertify.error('Please Enter/Scan AWB for RTO/FWD or Please scan Flyer to print sticker for DTO shipments');
                        if (this.shipment) {
                            this.shipment = '';
                        }
                        return false;
                    } else {
                        console.log('User Input detection .!');
                        return false;
                    }
                }
            }
        },
        // End Disable Manual Entry For Flyer Barcode
        /* Get One Pager Configuration here */
        checkOnePagerEnabled() {
            let RequestForOnePagerFlag = {
                "hubId": this.hubId
            };
            getOnePagerEnabledFlag(RequestForOnePagerFlag, (result) => {
                try {
                    if (result.data.code != 200) {
                        if (result.data.data == false) {
                            this.$router.push('/PrintLabel')
                        }
                    }
                } catch (error) {
                    console.log('result------', error.message);
                }
            })
        },
        reprintStricker() {
            /* Checking Fresh Print Role */
            let allowedPrintRole = '';
            if (this.shipResponseData.dbDetails && this.shipResponseData.dbDetails.printcount >= 1) {
                allowedPrintRole = this.shipResponseData.allowedReprintRole.map(item => item.toLowerCase());
            }
            if (allowedPrintRole.includes(this.userrole.toLowerCase())) {
              this.isShowReprintPopUp = true;
            } else {
              this.isShowReprintPopUpReprint = true;
              this.$alertify.error("You are not authorized to print stickers for this shipment.");
            }
          },
        detectInputForStickerPrintv1(event) {
            let currentTime = Date.now();

            if (this.lastKeyTime === 0 || this.lastKeyTime === null || this.lastKeyTime === undefined) {
                this.lastKeyTime = currentTime;
                return;
            }

            let timeDiff = currentTime - this.lastKeyTime;
            this.lastKeyTime = currentTime;

            this.isScannerInput = timeDiff < this.threshold;

            clearTimeout(this.scanTimeout);
            this.scanTimeout = setTimeout(() => {
                if (this.isScannerInput && this.shippingID.length > 6) {
                    this.submitform()
                }
            }, this.ttl);
        },
        handleInputForStickerPrintv1() {
            this.shippingID = (this.selected == 0 && this.shippingID) ? this.shippingID : this.shipment;
            if ($("#shippingID").val().trim().toUpperCase().startsWith('2') || $("#shipment").val().trim().toUpperCase().startsWith('2')) {
                this.$alertify.error('Please Scan Flyerbarcode for DTO Shipment.');
                if (this.shipment) {
                    this.shipment = '';
                }
                else {
                    this.shippingID = '';
                }
            } else {
                if (this.isScannerInput === false && this.shippingID.length > 3 && this.flyerBarcodeList.some(prefix => this.shippingID.toUpperCase().startsWith(prefix))) {
                    this.$alertify.error('Please Enter/Scan AWB for RTO or Scan Flyer Barcode for DTO');
                    if (this.shipment) {
                        this.shipment = '';
                    }
                    else {
                        this.shippingID = '';
                    }
                    return;
                }
            }
        },
        onPrinterChange(event) {
            console.log('Selected printer value:', this.isSelectPrinter);

            if (this.isSelectPrinter === '0') {
                // Old Print logic
                window.localStorage.setItem('onepagerprintflag',"Old");
            } else if (this.isSelectPrinter === '1') {
                // New Print logic
                window.localStorage.setItem('onepagerprintflag',"New");
            }
        }
    }
}

Validator.extend('santiseShippingID', {
    getMessage: field => 'Please enter valid AWB/Flyer code',
    validate: value => {
        let regexExpFlyerbarcode = /[!@#$%^&*`'[+~/(),.?":{}|<>]/;
        if (regexExpFlyerbarcode.test(value) == false) {
            return true;
        } else {
            return false;
        }
    }
})



// WEBPACK FOOTER //
// ./src/views/components/RVPPrintLabelNewv2/RVPPrintLabelNewv2.component.js